module.exports = __webpack_public_path__ + "static/newart4-4883855cb548c9f3938059d7ce0346a7.jpg";